export default __webpack_public_path__ + "static/media/search.12b6d661.svg";